import type { NavItemGroup } from "@/types";

export const appDashboardTopNav: NavItemGroup = {
  id: "ni-general",
  items: [
    {
      title: "Dashboard",
      href: "/dashboard",
      icon: "tasks",
      label: "Dashboard",
    },
  ],
};

export const appDashboarPrimaryNav: NavItemGroup = {
  id: "ni-projects",
  label: "Projects",
  items: [
    {
      title: "Website redesign",
      href: "/projects/s09a8sd-3op4ii3-s8d9sd9a-c87v98c7v",
      icon: "project",
      label: "Website redesign",
    },
    {
      title: "House renovation",
      href: "/projects/g89h8g9h-oiu2io3-s8d9s8d-l1k2lk123",
      icon: "project",
      label: "House renovation",
    },
    {
      title: "Metro station",
      href: "/projects/wd6v0d9-t9h8n7hn8-5q4a3z54-m9i0k0k9",
      icon: "project",
      label: "Metro station",
    },
    {
      title: "Autonomous taxi",
      href: "/projects/w0e78w8-8r7t78w9e-v78f87d62-87fh99s6",
      icon: "project",
      label: "Autonomous taxi",
    },
  ],
};

export const appAdminTopNav: NavItemGroup = {
  id: "ni-general",
  items: [
    {
      title: "Dashboard",
      href: "/dashboard",
      icon: "tasks",
      label: "Dashboard",
    },
  ],
};

export const appAdminPrimaryNav: NavItemGroup = {
  id: "ni-general",
  items: [
    {
      title: "Details",
      href: "/admin",
      icon: "organization",
      label: "Details",
    },
    {
      title: "Capabilites",
      href: "/admin/services",
      icon: "services",
      label: "Capabilities",
    },
    {
      title: "Rate cards",
      href: "/admin/rate-cards",
      icon: "rateCards",
      label: "Rate cards",
    },
    {
      title: "Locations",
      href: "/admin/locations",
      icon: "office",
      label: "Locations",
    },
    {
      title: "Members",
      href: "/admin/members",
      icon: "people",
      label: "Members",
    },
    {
      title: "Agents",
      href: "/admin/agents",
      icon: "ai",
      label: "Agents",
    },
    {
      title: "Settings",
      href: "/admin/settings",
      icon: "settings",
      label: "Settings",
    },
  ],
};

export const appSuperAdminPrimaryNav: NavItemGroup = {
  id: "super-admin",
  items: [
    {
      title: "Dashboard",
      href: "/sa/super",
      icon: "dashboard",
      label: "Dashboard",
    },
    {
      title: "Organizations",
      href: "/sa/super/organizations",
      icon: "organization",
      label: "Organizations",
    },
    {
      title: "Invites",
      href: "/sa/super/invites",
      icon: "invites",
      label: "Invites",
    },
    {
      title: "Data",
      href: "/sa/super/data",
      icon: "data",
      label: "Data",
    },
    {
      title: "User credits",
      href: "/sa/super/plan-credits",
      icon: "rateCards",
      label: "User credits",
    },
    {
      title: "Plan catalog",
      href: "/sa/super/plan-catalog",
      icon: "organization",
      label: "Plan catalog",
    },
    {
      title: "Entitlements",
      href: "/sa/super/entitlements",
      icon: "data",
      label: "Entitlements",
    },
  ],
};

export const appAdminSecondaryNav: NavItemGroup = {
  id: "ni-general",
  items: [
    {
      title: "My Account",
      href: "/my-account",
      icon: "organization",
      label: "My Account",
    },
  ],
};
